import {BankAccount} from '@modules/husleie-framework/src/types/BankAccount.entity';
import type {PaymentMethodEnum} from '@modules/husleie-framework/src/types/Payment.entity';
import {SingleSelectButtonGroup} from '@modules/husleie-framework/src/types/SingleSelectButtonGroup.entity';

const enum UpsellOpportunityEnum {
  DEPOSIT_SUBSCRIPTION = 'DEPOSIT_SUBSCRIPTION',
  DEPOSIT_ACCOUNT = 'DEPOSIT_ACCOUNT',
  ELECTRICITY = 'ELECTRICITY',
  TENANCY_SUBSCRIPTION = 'TENANCY_SUBSCRIPTION',
}
type UpsellOpportunityType =
  | UpsellOpportunityEnum.DEPOSIT_SUBSCRIPTION
  | UpsellOpportunityEnum.DEPOSIT_ACCOUNT
  | UpsellOpportunityEnum.ELECTRICITY
  | UpsellOpportunityEnum.TENANCY_SUBSCRIPTION;

const enum UpsellStatusEnum {
  OPEN = 'OPEN',
  PREORDERED = 'PREORDERED',
  ORDERED = 'ORDERED',
  INTERESTED = 'INTERESTED',
  DECLINED = 'DECLINED',
  PRISTINE = 'PRISTINE',
  CREDTIT_CHECK = 'CREDTIT_CHECK',
  PAYMENT = 'PAYMENT',
  MANUAL = 'MANUAL',
  SIGNING = 'SIGNING',
  CANCELED = 'CANCELED',
  COMPLETE = 'COMPLETE',
}
type UpsellStatusType =
  UpsellStatusEnum.OPEN |
  UpsellStatusEnum.PREORDERED |
  UpsellStatusEnum.ORDERED |
  UpsellStatusEnum.INTERESTED |
  UpsellStatusEnum.DECLINED |
  UpsellStatusEnum.PRISTINE |
  UpsellStatusEnum.CREDTIT_CHECK |
  UpsellStatusEnum.PAYMENT |
  UpsellStatusEnum.MANUAL |
  UpsellStatusEnum.SIGNING |
  UpsellStatusEnum.CANCELED |
  UpsellStatusEnum.COMPLETE;

interface UpsellCustomer {
  payment: {
    method: null | PaymentMethodEnum;
    bankAccount?: null | BankAccount;
  };
}

type UpsellOpportunity = {
  type: UpsellOpportunityType;
  uuid?: string;
  status?: UpsellStatusType;
}

type UpsellPartnerType = {
  name?: string;
  component?: string;
  images?: {
    logo?: UpsellPartnerLogo;
    additionalLogo?: UpsellPartnerLogo;
  };
  benefits?: [any];
  terms?: any;
  url?: string;
  options?: SingleSelectButtonGroup;
};

type UpsellPartnerLogo = {
  alt: string;
  path: string;
};

enum UpsellKYCErrorEnum {
  MANUAL_REVIEW = 'Manual review required',
  VERIFICATION_FAILED = 'Customer failed identity verification',
}

enum UpsellInstabankKYCError {
  PayloadNotInExpectedFmt = 'Payload is not in expected format',
  CouldNotFindProvidedDepAcc = 'Could not find the provided deposit account',
  KYCAlreadyCompleted = 'KYC already completed',
  KYCRejected = 'KYC has been rejected',
  KYCAlreadySubmitted = 'KYC already submitted',
  UserHasNotAcceptedTerms = 'SecurityDeposit: User has not accepted terms',
  MissingNationality = 'SecurityDeposit: Missing nationality',
  InvalidSSNLength = 'SecurityDeposit: Invalid nationality length',
  InvalidSSN = 'SecurityDeposit: Invalid SSN',
  SSNAreEqual = 'SecurityDeposit: SSN are equal',
  FailedDueTo = 'Instabank DepAcc creation validation failed due to',
  ErrorFromInstabank = 'Got error back from Instabank',
  UnknownStatus = 'Got UNKNOWN status from bank partner',
  CouldNotUpdateDepAcc = 'Could not update deposit account',
  SSNNotApprovedByExperian = 'Experian failure for social security or organization number',
  KYCNotApprovedByBank = 'KYC was not approved by bank',
  UnexpectedResponse = 'Unexpected response from Deposit Vendor',
  UnknownError = 'Unknown error',
}

export {
  UpsellOpportunityEnum,
  UpsellOpportunityType,
  UpsellOpportunity,
  UpsellStatusEnum,
  UpsellStatusType,
  UpsellCustomer,
  UpsellPartnerType,
  UpsellPartnerLogo,
  UpsellKYCErrorEnum,
  UpsellInstabankKYCError,
};
